export default __webpack_public_path__ + "static/media/account.355b029e.png";